import { Box, Button, Typography } from "@mui/material";
import { AvailabilitySetup } from "lib/features/availability/types";
import { useNavigate } from "react-router-dom";
import { BookingType } from "../utils/itemBookingType";

interface AvailabilityHeaderProps {
  availabilitySetup: AvailabilitySetup | null;
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  bookingType: BookingType | null;
}

const AvailabilityHeader = ({
  availabilitySetup,
  step,
  setStep,
  bookingType,
}: AvailabilityHeaderProps) => {
  const navigate = useNavigate();
  return (
    <Box>
      <Box
        sx={{
          padding: "1rem",
          marginRight: "auto",
          marginLeft: "auto",
          maxWidth: {
            xs: "100vw", // small
            sm: "60vw", // tab
            md: "40vw", // large
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {step > 1 && (
            <Button
              type="button"
              onClick={() => setStep((prevStep) => prevStep - 1)}
            >
              <Typography>Back</Typography>
            </Button>
          )}
          <Typography sx={{ fontSize: "17px", fontWeight: "600" }}>
            {step === 2 && bookingType === BookingType.REQUEST_TO_BOOK
              ? "Request to Book"
              : "Add Availability"}
          </Typography>

          <Button
            type="button"
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
            onClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          marginRight: "auto",
          marginLeft: "auto",
          maxWidth: {
            xs: "90vw", // small
            sm: "60vw", // tab
            md: "40vw", // large
          },
        }}
      >
        <Typography
          sx={{
            fontSize: "1rem",
          }}
        >
          Step
          <Typography
            component="span"
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
            }}
          >
            {" " + step + " "}
          </Typography>
          of 2
        </Typography>
        <Typography variant="h1" component="h1">
          {step === 1 && "Set Availability"}
          {step === 2 &&
            (availabilitySetup?.private
              ? "Review and Share"
              : "Review Availability and Publish")}
        </Typography>
        <Typography
          sx={{
            color: "gray",
            fontSize: "0.8rem",
          }}
        >
          *Required fields
        </Typography>
      </Box>
    </Box>
  );
};

export default AvailabilityHeader;
